import React, { PropsWithChildren, ReactNode } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  roles: string[];
  fallBack?: ReactNode;
}

export const DocumentAttributePermissions = ({ children, roles, fallBack = null }: PropsWithChildren<Props>) => {
  const userRole = useSelector<any, string>(state => state.userProfile.vendorContactRole);

  const isAvailable = !roles.length || roles.includes(userRole);

  return <>{isAvailable ? children : fallBack}</>;
};
